import styled from "@emotion/styled";
// import { Icon } from "../../../components/UIKitComponents/Icon/Icon";

export const Image = styled("img")`
  max-width: 120px;
  max-height: 120px;
  min-width: 100%;
  min-height: 100%;
`;

export const ImageWrap = styled("div")`
  position: relative;
  width: 120px;
  height: 120px;
  border: 6px solid rgba(193, 193, 217, 0);
  border-radius: 6px;
  overflow: hidden;

  &:hover {
    border: 6px solid rgba(193, 193, 217, 0.3);
  }
`;

export const MessageStatus = styled("div")`
  position: relative;
  display: inline-block;
  margin: 0 0 0 5px;
  top: 4px;

  .icon {
    width: 18px;
    height: 18px;
  }
`;

export const MessageItemStyles = styled("div")`
  display: flex;
  margin: 5px 0;
  transition: opacity 0.5s ease-out 0s;
  opacity: 1;

  &.--in {
  }
  &.--out {
    justify-content: flex-end;
    margin-right: 20px;
  }

  &.--invisible {
    opacity: 0;
  }

  .msg {
    &__sender {
      display: flex;
      align-items: flex-end;
    }

    &__avatar {
      margin: 0 10px 0 20px;
    }

    &__body {
      width: 60%;
      padding: 12px;

      &.--in {
        color: #4a5580;
        background-color: #f8f8fd;
        border-radius: 6px 6px 6px 0;
      }
      &.--out {
        color: #1c2134;
        background-color: #dfdff3;
        border-radius: 6px 6px 0 6px;
      }
    }

    &__text {
      line-height: 19.2px;
    }

    &__bottom {
      text-align: right;
    }

    &__text {
      &.--in {
        color: #4a5580;
      }
      &.--out {
        color: #1c2134;
      }
    }

    &__time {
      &.--in {
        color: #9499ac;
      }
      &.--out {
        color: #4a5580;
      }
    }

    &__sender-name {
      margin-right: 10px;

      &.--in {
        color: #4a5580;
      }
      &.--out {
        color: #4a5580;
      }
    }
  }
`;
